const detectBots = () => {
    return /bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent);
}

export default detectBots;
